import React from 'react'
import { isAccessAllowed } from '../dashboard/hooks/userHooks'

export function ShowForRejectedPermissionsOnly({ toCheck = [], children }) {
    return isAccessAllowed(toCheck) ? null : children;
}